import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/common/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NewNavBar"] */ "/vercel/path0/src/components/common/NewNavBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/event/Category.tsx");
